import { ISomeOrder } from './types';
import { IOrder } from 'Modules/Cart/types';

const DASH = /_/g;
const SPACE = ' ';

export function convertDashToSpace(obj: any) {
  return Object.keys(obj).reduce((result: any, p: string) => {
    result[p.replace(DASH, SPACE)] = obj[p];
    return result;
  }, {});
}

export function calcOrderSize(order: ISomeOrder) {
  return (order as IOrder).products
    ? (order as IOrder).products.reduce((count, p) => (p.amount || p.weight ? count + 1 : count), 0)
    : 0;
}
